<template>
  <v-dialog
    v-model="dialog"
    max-width="500"
    @click:outside="$emit('update:dialog', false)"
  >
    <v-card>
      <v-card-title>ยืนยันการลบประกาศ</v-card-title>
      <v-card-actions>
        <v-btn color="primary" @click="$emit('submit')">ยืนยัน</v-btn>
        <v-btn color="error" @click="$emit('update:dialog', false)">ยกเลิก</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>    
</template>

<script>
export default {
  props: {
    dialog: Boolean,
    title: String
  }
}
</script>